import { render } from "./WpeForm.vue?vue&type=template&id=0dd92576"
import script from "./WpeForm.vue?vue&type=script&lang=js"
export * from "./WpeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dd92576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dd92576', __exports__)) {
    api.reload('0dd92576', __exports__)
  }
  
  module.hot.accept("./WpeForm.vue?vue&type=template&id=0dd92576", () => {
    api.rerender('0dd92576', render)
  })

}


export default __exports__